var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading.general,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading.general && _vm.records.length
            ? [
                false
                  ? _c(
                      "div",
                      { staticClass: "text-right mb-1" },
                      [
                        _c("LoadingButton", {
                          attrs: {
                            title: "Поиск нового отправления",
                            className: "btn btn-outline-info",
                            onClick: () => _vm.newTask(),
                            loading: _vm.loading.btn.newTask,
                            type: "button",
                            color: _vm.$constants.LOADING_COLOR,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table mt-0 table-sm table-hover" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.records, function (r, i) {
                          return [
                            _c("tr", [
                              _c(
                                "td",
                                { attrs: { rowspan: r.records.length + 1 } },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        i +
                                          1 +
                                          ((_vm.paginator?.current_page ?? 1) -
                                            1) *
                                            (_vm.paginator?.per_page ?? 1)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "p-0 border-0" }),
                              _vm._v(" "),
                              _c("td", { staticClass: "p-0 border-0" }),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { rowspan: r.records.length + 1 } },
                                [
                                  _c("LoadingButton", {
                                    attrs: {
                                      title: "Скачать",
                                      className: "btn btn-outline-success",
                                      onClick: () => _vm.generate(r),
                                      loading: _vm.loading.btn[r.id],
                                      type: "button",
                                      color: _vm.$constants.SUCCESS_COLOR,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { attrs: { rowspan: r.records.length + 1 } },
                                [_vm._v(_vm._s(_vm.printDate(r.created_at)))]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(r.records, function (f) {
                              return _c("tr", [
                                _c("td", [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(f.orderNumber) +
                                        " (" +
                                        _vm._s(f.orderDate) +
                                        ") " +
                                        _vm._s(f.cityFrom.name) +
                                        " -> " +
                                        _vm._s(f.cityTo.name)
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: `https://www.cdek.ru/ru/tracking?order_id=${f.orderNumber}`,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("track online")]
                                  ),
                                ]),
                              ])
                            }),
                          ]
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-right" },
                  [
                    _vm.paginator
                      ? _c("paginate", {
                          ref: "Pagination",
                          attrs: {
                            "page-count": _vm.paginator.last_page,
                            "page-range": 11,
                            "margin-pages": 2,
                            "click-handler": _vm.getRecords,
                            "prev-text": "&laquo",
                            "next-text": "&raquo",
                            "container-class": "pagination",
                            "prev-class": "page-item",
                            "prev-link-class": "page-link",
                            "page-class": "page-item",
                            "page-link-class": "page-link",
                            "next-class": "page-item",
                            "next-link-class": "page-link",
                            "active-class": "active green_btn",
                          },
                          model: {
                            value: _vm.paginator.current_page,
                            callback: function ($$v) {
                              _vm.$set(_vm.paginator, "current_page", $$v)
                            },
                            expression: "paginator.current_page",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { width: "70px" } }),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("ссылка")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("стикер")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "100px" } }, [_vm._v("Дата")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }